import React, { useEffect, useState } from "react";
import { Layout } from "../";
import { Loader, UpgradeContainer, TeamScores } from "../../components";
import { Container } from "./styled";
import { useHistory } from "react-router";
import secureLocalStorage from "react-secure-storage";
import { calculatePlayerStats, calculatePercj } from "../../lib/cabbStats";
import { Link } from "react-router-dom";

const Games = ({ appData }) => {
  const userLocal = secureLocalStorage.getItem("userLocal");
  const [isLoading, setIsLoading] = useState(true);
  const [games, setGames] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://deportactico-vercel-serverless.vercel.app/api/gamesByTeam?season=${process.env.REACT_APP_ACTIVE_SEASON}&teamId=${userLocal.teamId}`
        );
        const result = await response.json();
        setGames(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false); // Ensure loading is false after fetching
      }
    };

    fetchData();
  }, [userLocal]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <Layout isPositionUnset={true}>
      {userLocal !== undefined &&
      userLocal !== null &&
      userLocal !== null &&
      userLocal?.plan !== "Basic" ? (
        <Container>
          <TeamScores
            appData={appData}
            games={games}
            isTeamProfile={true}
            season={process.env.REACT_APP_ACTIVE_SEASON}
            activePhase={null}
            activeTeam={userLocal?.teamId}
          />
        </Container>
      ) : (
        <UpgradeContainer />
      )}
    </Layout>
  );
};

export default Games;
